import React from 'react';
import { Link } from 'react-router-dom';
import './TaylorPortfolio.css';

function TaylorPortfolio() {
  return (
    <div className="portfolio-page">
      <section className="portfolio-hero">
        <div className="container">
          <div className="profile-header">
            <img 
              src="https://tr.rbxcdn.com/30DAY-AvatarHeadshot-0950F98901D3A1850FA83BC533B6563D-Png/150/150/AvatarHeadshot/Webp/noFilter"
              alt="iownrena"
              className="profile-avatar"
            />
            <div className="profile-info">
              <h1>iownrena</h1>
              <p className="profile-role">@iownrena</p>
              <div className="profile-bio-section">
                <h3>Bio</h3>
                <p>
                  Hi, I'm Taylor — I've been programming in Lua/Luau for 7+ years. I mainly work on frameworks and gameplay systems.
                </p>
                <p>
                  In early 2024, I worked at Bloxlink from February to March. I made UML diagrams for their API and helped plan the backend. Bloxlink got acquired by Roblox on July 30th, 2024.
                </p>
                <p>
                  I make projects with my girlfriend and run MeowBox Studios where I'm the Lead Developer and do most of the programming.
                </p>
                <p>
                  I've worked on a lot of different Roblox games over the years and I'm always down to work with new people if we're making something cool.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="showcase-section">
        <div className="container">
          <h2>Work Showcase</h2>
          <div className="showcase-grid">
            <div className="showcase-item video-item">
              <video src="https://cdn.meowboxstudios.com/2025-11-15_17-52-45.mp4" controls muted loop />
              <p className="showcase-label">Shop UI Scripted</p>
            </div>
          </div>
        </div>
      </section>

      <section className="projects-section">
        <div className="container">
          <h2>Projects</h2>
          <div className="projects-list">
            <div className="project-card">
              <h3>Pick up the Phone Horror</h3>
              <p className="project-role">Lead Developer</p>
              <p className="project-description">
                a Game Based off the Blackphone 2 Horror..
              </p>
              <div className="project-tech">
                <span className="tech-tag">Luau</span>
                <span className="tech-tag">Scripting</span>
                <span className="tech-tag">Backend</span>
                <span className="tech-tag">Gameplay</span>
              </div>
            </div>
            <div className="project-card">
              <h3>Level 974 – MrKitty's Home</h3>
              <p className="project-role">Lead Developer</p>
              <p className="project-description">
                Mr Kitty is a Backrooms Horror Game, we're actively working on this
              </p>
              <div className="project-tech">
                <span className="tech-tag">Luau</span>
                <span className="tech-tag">Networking</span>
                <span className="tech-tag">Performance</span>
                <span className="tech-tag">Systems</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="work-history-section">
        <div className="container">
          <h2>Work History</h2>
          <div className="work-list">
            <div className="work-card">
              <h3>CNA Simulator</h3>
              <p className="work-role">Programmer</p>
              <p className="work-date">Jun 2025 - Present</p>
              <p className="work-description">
                Programmer & Anti-Cheat
              </p>
            </div>

            <div className="work-card">
              <h3>Build a Car to Kill Zombies</h3>
              <p className="work-role">Commissioned Programmer</p>
              <p className="work-date">Feb 2025 - Mar 2025</p>
              <p className="work-description">
                I worked on a Valentine's Day update after being brought on by kenz as a programmer. My role was to add new features, improve code flow, and help clean up existing systems. I also worked alongside do_big and programmerthe during this update.
              </p>
            </div>

            <div className="work-card">
              <h3>Mall Drifters</h3>
              <p className="work-role">Temp-Programmer</p>
              <p className="work-date">Jan 2025 - Jan 2025</p>
              <p className="work-description">
                I worked on major bugs affecting the physics, movement, and driving-related systems. These issues were causing noticeable problems for players and hurting the overall experience. I fixed the core problems, stabilized key systems, and wrapped up my work once everything was running smoothly.
              </p>
            </div>

            <div className="work-card">
              <h3>Skate Central</h3>
              <p className="work-role">Contribution Programmer</p>
              <p className="work-date">May 2024 - Jul 2024</p>
              <p className="work-description">
                Core & Backend
              </p>
            </div>

            <div className="work-card">
              <h3>Roblox Chat Simulator 2</h3>
              <p className="work-role">Senior Developer</p>
              <p className="work-date">Jun 2022 - Aug 2022</p>
              <p className="work-description">
                As a Senior Developer, I handle UI concepts, feature planning, and overall workflow stability for the community. I also take care of moderation tasks and resolve script errors and bugs to keep everything running smoothly.
              </p>
              <p className="work-description">
                I've managed partnerships, added partner badges, updated in-game badges, and created assets for Roblox Chat Simulator 2. I've also collaborated with PozziDev/FanSim, and together we've reached over 18 million visits.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="experience-section">
        <div className="container">
          <h2>Experience</h2>
          <div className="experience-card">
            <h3>Co-Founder & Lead Developer</h3>
            <p className="experience-company">MeowBox Studios</p>
            <p className="experience-date">November 2025 - Present</p>
            <p className="experience-description">
              Co-founded a Roblox horror studio. I handle all the programming and technical stuff for our games.
            </p>
          </div>
        </div>
      </section>

      <section className="links-section">
        <div className="container">
          <h2>Links</h2>
          <div className="links-grid">
            <a href="https://devforum.roblox.com/u/iownrena" className="link-btn" target="_blank" rel="noopener noreferrer">
              DevForum Profile
            </a>
            <a href="mailto:careers@meowboxstudios.com" className="link-btn">
              Contact Me
            </a>
            <Link to="/team" className="link-btn">
              Back to Team
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TaylorPortfolio;
